import axios from "axios";
import React, { useEffect } from "react";
import { useState } from "react";
import toast from "react-hot-toast";
import { Link } from "react-router-dom";

const QuestionsList = () => {
  const [questionsList, setQuestionsList] = useState([]);

  const questionDeleteHandler = async (id) => {
    try {
      await axios.delete(`/questions/${id}/delete`);
      toast.success("Question deleted successfully!");
      fetchQuestions();
    } catch (err) {
      console.log(err);
      toast.error(
        err?.response?.data?.msg ||
          "Something went wrong! Please try again later"
      );
    }
  };

  const fetchQuestions = () => {
    axios
      .get("/questions")
      .then((res) => {
        setQuestionsList(res.data.questions);
      })
      .catch((err) => {
        console.log(err);
        toast.error(
          (err?.response?.data?.errors && err?.response?.data?.errors[0]) ||
            "Something went wrong while fetching the next release date"
        );
      });
  };

  useEffect(() => {
    fetchQuestions();
  }, []);

  return (
    <div className="py-20 sm:py-24 px-4 sm:px-6 md:px-10">
      <div className="max-w-6xl mx-auto">
        <Link to="/add-question">
          <h5 className="text-xl sm:text-2xl md:text-3xl text-emerald-600 underline decoration-emerald-200 hover:decoration-emerald-500 text-center mb-5 sm:mb-6 font-semibold transition-colors">
            + Add Question
          </h5>
        </Link>

        {/* Desktop Table */}
        <div className="hidden md:block bg-white/80 backdrop-blur-2xl border border-white/40 rounded-2xl shadow-xl overflow-hidden">
          <table className="min-w-full text-left text-sm">
            <thead>
              <tr className="bg-emerald-50/80 border-b border-emerald-100">
                <th className="px-6 py-4 font-semibold text-slate-700 text-xs uppercase tracking-wider">#</th>
                <th className="px-6 py-4 font-semibold text-slate-700 text-xs uppercase tracking-wider">Question</th>
                <th className="px-6 py-4 font-semibold text-slate-700 text-xs uppercase tracking-wider">Correct Option</th>
                <th className="px-6 py-4 font-semibold text-slate-700 text-xs uppercase tracking-wider">Display Date</th>
                <th className="px-6 py-4 font-semibold text-slate-700 text-xs uppercase tracking-wider">Actions</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100">
              {questionsList.map((el, idx) => (
                <tr key={el._id} className="hover:bg-emerald-50/40 transition-colors">
                  <td className="px-6 py-4 font-medium text-slate-800">{idx + 1}</td>
                  <td className="px-6 py-4 text-slate-700 max-w-xs truncate">{el.english}</td>
                  <td className="px-6 py-4 text-slate-600">{el.options.find((el) => el.isCorrect)?.english}</td>
                  <td className="px-6 py-4 text-slate-600">{new Date(el.releaseDate).toLocaleDateString()}</td>
                  <td className="px-6 py-4">
                    <div className="flex gap-3 items-center">
                      <Link to={`/edit-question/${el._id}`}>
                        <button className="bg-emerald-600 hover:bg-emerald-700 text-white px-4 py-2 rounded-xl text-sm font-medium transition-all hover:-translate-y-0.5 hover:shadow-md shadow-sm">
                          Edit
                        </button>
                      </Link>
                      <img
                        onClick={() => questionDeleteHandler(el._id)}
                        className="cursor-pointer hover:scale-110 transition-transform w-5 h-5"
                        src="/assets/imgs/bin.svg"
                        alt="delete"
                      />
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Mobile Cards */}
        <div className="md:hidden space-y-3">
          {questionsList.map((el, idx) => (
            <div key={el._id} className="bg-white/80 backdrop-blur-2xl border border-white/40 rounded-2xl p-4 shadow-md">
              <div className="flex items-start justify-between mb-2">
                <span className="inline-flex items-center justify-center w-7 h-7 rounded-full bg-emerald-100 text-emerald-700 text-xs font-bold">{idx + 1}</span>
                <span className="text-xs text-slate-500">{new Date(el.releaseDate).toLocaleDateString()}</span>
              </div>
              <p className="text-sm font-medium text-slate-800 mb-1 line-clamp-2">{el.english}</p>
              <p className="text-xs text-slate-500 mb-3">
                <span className="text-emerald-600 font-medium">Correct:</span> {el.options.find((el) => el.isCorrect)?.english}
              </p>
              <div className="flex gap-3 items-center">
                <Link to={`/edit-question/${el._id}`}>
                  <button className="bg-emerald-600 hover:bg-emerald-700 text-white px-4 py-1.5 rounded-xl text-xs font-medium transition-all shadow-sm">
                    Edit
                  </button>
                </Link>
                <img
                  onClick={() => questionDeleteHandler(el._id)}
                  className="cursor-pointer hover:scale-110 transition-transform w-5 h-5"
                  src="/assets/imgs/bin.svg"
                  alt="delete"
                />
              </div>
            </div>
          ))}
        </div>

        {questionsList.length === 0 && (
          <div className="text-center py-10 text-slate-500 bg-white/80 backdrop-blur-2xl border border-white/40 rounded-2xl shadow-xl">
            No questions found
          </div>
        )}
      </div>
    </div>
  );
};

export default QuestionsList;
